export default __webpack_public_path__ + "static/media/pf.812f5d80.jpg";